import React from 'react'
import NoDataIcon from '../../../assets/icons/icons-no-table-data.png'
export default function NoDataTable() {
  return <img src={NoDataIcon} />
}
